import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=fa75cdb8&scoped=true&"
import script from "./Book.vue?vue&type=script&lang=js&"
export * from "./Book.vue?vue&type=script&lang=js&"
import style0 from "./Book.vue?vue&type=style&index=0&id=fa75cdb8&lang=scss&scoped=true&"
import style1 from "./Book.vue?vue&type=style&index=1&id=fa75cdb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa75cdb8",
  null
  
)

export default component.exports